import { Row } from 'antd'
import Container from 'components/Container'
import styled, { css } from 'styled-components'
import { borderRadius, color, padding } from 'theme/mixins'

const ExpandableContainer = styled(Row)<{ $collapsed: boolean }>`
	position: relative;
	overflow: hidden;

	${({ $collapsed }) =>
		$collapsed &&
		css`
			max-height: 160px;
		`}
`

const ExpandButtonContainer = styled(Container)`
	display: flex;
	justify-content: center;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding-top: ${padding('lg')};
	padding-bottom: ${padding('sm')};
	background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 1) 50%);
`

const BlockchainNameItem = styled.div`
	border-radius: ${borderRadius('sm')};
	text-align: center;
	background: ${color(['gray', '100'])};
`

export default { ExpandableContainer, ExpandButtonContainer, BlockchainNameItem }
